import type { TranslationFunctions } from '@i18n/i18n-types';

export function getPlaceLabel($LL: TranslationFunctions, place: number | undefined): string {
    if (place === undefined) {
        return $LL.income.na();
    }

    return place >= 999 || place === -1 ? '#999+' : `#${place.toString()}`;
}
